/**
 * ============================================
 * APEX MEDICAL GROUP - CONTACT CONFIGURATION
 * ============================================
 * 
 * Single source of truth for all business and clinician contact information.
 * Used across PDF generators, email templates, and UI components.
 */

// Main business contact numbers
export const BUSINESS_PHONES = [
  '+1-(758)-488-8433',
  '+1-(758)-485-0863',
  '+1-(758)-724-5394',
];

// Formatted for single-line display (pipe-separated)
export const BUSINESS_PHONES_INLINE = BUSINESS_PHONES.join(' | ');

// Clinic branding constants
export const CLINIC_NAME = 'Apex Medical Group';
export const CLINIC_ADDRESS = 'Corinth, Gros-Islet, Saint Lucia';
export const CLINIC_EMAIL = 'info@apexmedical.lc';

// Clinician personal phone mapping
// Keys are lowercase full names for flexible matching
export const CLINICIAN_PHONES = {
  'rashad prospere': '+1-(758)-488-8433',
  'dr. rashad prospere': '+1-(758)-488-8433',
  'le-ann yarde': '+1-(758)-485-0863',
  'dr. le-ann yarde': '+1-(758)-485-0863',
  'chamane peniston-prospere': '+1-(758)-724-5394',
  'dr. chamane peniston-prospere': '+1-(758)-724-5394',
};

/**
 * Get a clinician's personal phone number by name.
 * Matches against known clinician names (case-insensitive).
 * @param {string} name - The clinician's name
 * @returns {string|null} The personal phone number or null
 */
export const getClinicianPhone = (name) => {
  if (!name) return null;
  const normalized = name.toLowerCase().trim();
  // Direct match
  if (CLINICIAN_PHONES[normalized]) return CLINICIAN_PHONES[normalized];
  // Partial match (e.g. "Rashad Prospere" matches "rashad prospere")
  for (const [key, phone] of Object.entries(CLINICIAN_PHONES)) {
    if (normalized.includes(key) || key.includes(normalized)) return phone;
  }
  return null;
};
